<template>
  <div>
    <library-header/>
    <section class="library-content has-side-bar">
      <aside class="content-approval-sidebar">
        <library-sidebar />
      </aside>
      <div class="team-admin-panel">
        <div class="subheader">
          <h2 class="title">
            {{ $t("TEAM_ADMIN") }}
          </h2>
          <div class="search-team-member">
            <input
              id="filter-text-box"
              type="text"
              class="search-team-member-input"
              :placeholder="$t('SEARCH')"
              v-model="searchText"
              @input="searchTeamMember"
            />
          </div>
        </div>
        <button class="common-button button-publish-library main" @click="addStaffList">
          <svg
            class="add-icon"
            id="Component_105_1"
            data-name="Component 105 – 1"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
          >
            <rect
              id="Rectangle_2617"
              data-name="Rectangle 2617"
              class="cls-1"
              width="3"
              height="22"
              rx="1.5"
              transform="translate(9.5)"
            />
            <rect
              id="Rectangle_2618"
              data-name="Rectangle 2618"
              class="cls-1"
              width="3"
              height="22"
              rx="1.5"
              transform="translate(22 9.5) rotate(90)"
            />
          </svg>
          <span class="text">{{ $t('STAFF') }}</span>
        </button>
        <div class="banner-updating" v-if="isPipelineRunning">
          <p class="text">{{$t('ATTENTION')}}: {{$t('UPDATING_DATA_MSG')}}</p>
        </div>
        <div class="team-admin-panel-content">
          <staff-list-table ref="staff-list-table"/>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import LibraryHeader from '@/components/library-header'
import StaffListTable from '@/components/staff-list-table'
import { htmlParser } from '@/utilityFunctions'
import librarySidebar from '@/components/sidebar'
import { mapState } from 'vuex'

export default {
  name: 'staff-list-panel',

  data () {
    return {
      searchText: null
    }
  },

  components: { StaffListTable, LibraryHeader, librarySidebar },

  computed: {
    ...mapState({
      isPipelineRunning: state => state.pipelines.isPipelineRunning
    })
  },

  methods: {
    addStaffList () {
      this.$router.push({ name: 'staffListUpload' })
    },
    searchTeamMember () {
      const agTable = this.$refs['staff-list-table'].$refs['ag-grid-vue']
      // Search results by searchText
      agTable.gridOptions.api.setQuickFilter(
        this.searchText
      )
      // Highlight the search-text for each result row
      agTable.gridOptions.api.forEachNode(info => {
        info.setData({
          // Highlight the search-text for each result cell
          NAME: this.getHighlightText(htmlParser(info.data.NAME)),
          EMAIL: this.getHighlightText(htmlParser(info.data.EMAIL)),
          PERMISSION: this.getHighlightText(htmlParser(info.data.PERMISSION)),
          ORGANIZATION: this.getHighlightText(htmlParser(info.data.ORGANIZATION)),
          REMOVE: info.data.REMOVE
        })
      })
    },
    getHighlightText (text) {
      // If we have a searchText,
      // Replace all the searchText results with a `b` tag.
      if (!this.searchText) return text
      return text.replace(new RegExp(this.searchText, 'gi'), match => {
        return '<span class="highlightText">' + match + '</span>'
      })
    }
  }
}
</script>
<style lang="scss">
.highlightText {
  background-color: #8ed1f4;
  font-size: inherit;
}
.add-member-dropdown{
  position: absolute; z-index: 10; inset-block-start: 90px; box-shadow: 0 3px 6px #00000029;;
  min-width: 165px; background-color: #fff; border-radius: 3px;
  animation: fadein .5s; width: fit-content;
  display: flex; flex-direction: column;
  a{
    padding: 10px 20px; cursor: pointer;
    &:first-of-type{margin-top: 15px;}
    &:last-of-type{margin-bottom: 15px;}
    &:hover{background-color: #DCF2FF;}
  }
}
</style>
